import React from 'react';
import DefaultScreen from '@components/Global/DefaultScreenView';
import { Title } from '@constants/Themed';

const Branding = () => {
  return (
    <DefaultScreen>
      <Title>Branding Screen</Title>
    </DefaultScreen>
  )
}
export default Branding;